import Chip from '@mui/material/Chip';

import getPriorityColor from '@/components/PriorityChip/priorityColor.utils';

import type PriorityChipProps from './PriorityChip.types';

const PriorityChip = (props: PriorityChipProps) => {
  const { priority } = props;
  if (!priority) {
    return '--';
  }
  return <Chip label={priority} color={getPriorityColor(priority)} />;
};

export default PriorityChip;
